import { Routes } from '@angular/router';
import { provideUserStore } from '@app/store/user';
import { provideFormOptionsStore } from '@app/store/form-options';
import { ModalComponent } from '@shared/components';
import { AddComponent } from './add/add.component';
import { ViewComponent } from './view/view.component';
import { EditComponent } from './edit/edit.component';

export const usersModalRoutes: Routes = [
    {
        path: 'users/add',
        component: ModalComponent,
        outlet: 'modal',

        providers: [...provideUserStore()],
        children: [{ path: '', component: AddComponent }],
    },
    {
        path: 'users/view/:id',
        component: ModalComponent,
        outlet: 'modal',

        providers: [...provideUserStore()],
        children: [{ path: '', component: ViewComponent }],
    },
    {
        path: 'users/edit/:id',
        component: ModalComponent,
        outlet: 'modal',

        providers: [...provideUserStore(), ...provideFormOptionsStore()],
        children: [{ path: '', component: EditComponent }],
    },
];
